import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import EmptyList from "../../../components/ui/EmptyList";
import Workspace from "../../../components/workspace";
import Role from "./Role";
import RoleForm from "./role-form";

const Roles = ({ roles = [] }) => {
   const [selectedRole, setSelectedRole] = useState(null);
   const formModal = useDisclosure();

   if (!roles.length) return <EmptyList message="Roles would be listed here" />;
   return (
      <>
         <RoleForm modal={formModal} id={selectedRole?.id} setSelectedRole={setSelectedRole} />
         <Workspace.ListWrapper>
            {roles.map((_role, key) => (
               <Role role={_role} key={key} formModal={formModal} setSelectedRole={setSelectedRole} />
            ))}
         </Workspace.ListWrapper>
      </>
   );
};

export default Roles;
